import { EmailRecipient } from "@pulse/pulse-rpcs/lib/email-cycle/emailRecipient";
import { EmailStatus } from "@pulse/pulse-rpcs/lib/types/emailStatus";
import { EMPTY_CHARACTER } from "@pulse/shared-components";
import { Instance, SnapshotIn, types } from "mobx-state-tree";

export const EmailCycleRecipientModel = types
  .model("EmailCycleRecipientModel", {
    id: types.string,
    respondentId: types.integer,
    email: types.string,
    addedOn: types.string,
    status: types.enumeration(
      "EmailCycleRecipientStatus",
      Object.values(EmailStatus.EmailStatus),
    ),
  })
  .actions((store) => ({
    setEmailCycleRecipient: (recipient: EmailRecipient): void => {
      store.id = recipient.id.uuid;
      store.respondentId = recipient.respondentId;
      store.email = recipient.email;
      store.addedOn = recipient.addedOn.timestamp;
      store.status = recipient.status;
    },
  }));

export const createEmailCycleRecipientModel = (
  recipient?: SnapshotIn<typeof EmailCycleRecipientModel>,
): Instance<typeof EmailCycleRecipientModel> =>
  EmailCycleRecipientModel.create(
    recipient ?? {
      id: EMPTY_CHARACTER,
      respondentId: 0,
      email: EMPTY_CHARACTER,
      addedOn: EMPTY_CHARACTER,
      status: EmailStatus.EmailStatus.QUEUED,
    },
  );
